import {json} from 'd3-fetch';
import { renderSvelteComponent, findElementByIdInShadowDom } from "./utils/render";
import table from './components/Table.svelte';



async function main(){

  const url = new URL('../_data/reports.json', import.meta.url);
  const data = await json(url);

  renderSvelteComponent(
    table,
    (findElementByIdInShadowDom('lab-results-table')),
    {
      data: data,
      showModal: false,
    }
  );  
 

}
main()